import React, { Fragment } from "react";
import { useTranslation } from 'react-i18next';

export default function Variations(props) {
    const { t } = useTranslation();

  const allVariations = props.variations
    ? props.variations
      .filter(variation => variation.variableId === props.variableId)
      .map((variation, i) => (
        <option key={variation.id} value={variation.id}>
          {variation.variationValue}
        </option>
      ))
    : [];

  return (
    <Fragment>
          <option key="-1" value="-1">{t("Please select")} </option>
      {allVariations}
    </Fragment>
  );
}
